import React, { FC } from 'react';

interface PixelProps {
  src: string;
  onLoad?: () => void;
  onError?: () => void;
}

export const Pixel: FC<PixelProps> = ({ src, onLoad, onError }) => {
  return (
    <img
      src={src}
      width="1"
      height="1"
      alt=""
      style={{ display: 'none' }}
      onLoad={onLoad}
      onError={onError}
    />
  );
};
